import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { LeaseCalculator } from "./components/Calculator/LeaseCalculator";
import { EmbedCalculator } from "./components/Calculator/EmbedCalculator";
import Dashboard from "./components/Dashboard/InvestorDashboard";
import NotFound from "./components/NotFound";

function App() {
    return (
        <LanguageProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LeaseCalculator />} />
                        <Route path="/embed" element={<EmbedCalculator />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </div>
        </LanguageProvider>
    );
}

export default App;
